<app-wrapper>
  <div class="mb-9">
    <div class="row g-3 mb-4">
      <div class="col-auto">
        <h2 class="mb-0">Сторис</h2>
      </div>
    </div>

    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
        </div>
        <div class="col-auto flex-grow-1">

        </div>
        <div class="col-auto">
          <button routerLink="/stories/edit/new" class="btn btn-primary">
            <i class="fa-solid fa-plus"></i>&nbsp;Добавить
          </button>
        </div>
      </div>
    </div>

    <div class="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
      <div class="table-responsive mx-n1 px-1">
        <table class="table fs--1 mb-0">
          <thead>
            <tr>
              <th style="width: 30%;">Название</th>
              <th style="width: 20%;" class="text-center">Дата создания</th>
              <th style="width: 20%;" class="text-center">Статус</th>
              <th style="width: 20%;" class="text-center">Действия</th>
            </tr>
          </thead>
          <tbody class="list">
            @for (item of items; track item) {
            <tr>
              <td>
                <a [routerLink]="['/stories/edit', item.id]">{{ item.name }}</a>
              </td>
              <td class="text-center">
                {{ item.created | date: 'dd.MM.yyyy HH:mm' }}
              </td>
              <td class="text-center">
                <i class="fa-solid"
                  [ngClass]="{'text-danger': !item.isEnabled, 'text-success':item.isEnabled, 'fa-check': item.isEnabled, 'fa-times': !item.isEnabled}"></i>&nbsp;
                <span [ngClass]="{'text-success': item.isEnabled, 'text-danger': !item.isEnabled}">
                  {{ item.isEnabled ? 'Активна' : 'Неактивна' }}
                </span>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteItem(item)" title="Удалить">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            }
            @if (!isBusy && items.length == 0) {
            <tr>
              <td colspan="5" class="text-center">
                Список историй пуст
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    @if (isBusy) {
    <div class="overlay">
      <i class="fa-solid fa-spinner fa-spin"></i>
    </div>
    }
  </div>

</app-wrapper>